import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { initializeApp } from 'firebase/app';
import { Analytics, getAnalytics, isSupported, logEvent } from 'firebase/analytics';
import { filter } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  private analytics?: Analytics;
  private initialized = false;

  constructor(private readonly router: Router) {}

  async init(): Promise<void> {
    if (this.initialized || !environment.firebase.measurementId) {
      return;
    }

    const supported = await isSupported().catch(() => false);
    if (!supported) {
      return;
    }

    const app = initializeApp(environment.firebase);
    this.analytics = getAnalytics(app);
    this.initialized = true;

    this.logPageView(this.router.url || '/');

    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => this.logPageView(event.urlAfterRedirects));
  }

  private logPageView(path: string): void {
    if (!this.analytics) {
      return;
    }

    logEvent(this.analytics, 'page_view', {
      page_path: path,
      page_location: typeof window !== 'undefined' ? window.location.href : path
    });
  }
}
